import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";

import i18n from "./translation";
import Router from "./router";

/**
 * App entry point.
 *
 * Three things were wrong here before:
 *  - `ReactDOM.render` is the React 17 API. On React 18 it still works but logs
 *    a warning and opts the whole tree out of concurrent rendering.
 *  - `./translation` was never imported, so i18next was never initialised. Every
 *    `t("Contact")` was silently falling through to the raw key.
 *  - `I18nextProvider` was imported but never rendered.
 *  - `antd/dist/antd.css` shipped a full light-theme stylesheet on every page
 *    load to support three layout components. Those are gone; so is the import.
 */
const container = document.getElementById("root");

if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      {/* BrowserRouter, not HashRouter: theghostgame.com already rewrites every
          unknown path to index.html with a 200 (verified against production —
          /rules_of_conduct and a nonsense path both return 200), so real paths
          work with no hosting change. HashRouter would keep the #/ prefix and
          break the /privacy_policy URL the app-store listings point at. */}
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </I18nextProvider>
  </StrictMode>
);
